import { render, staticRenderFns } from "./VeSpacerBlockSettings.vue?vue&type=template&id=75f2cada"
import script from "./VeSpacerBlockSettings.vue?vue&type=script&lang=js"
export * from "./VeSpacerBlockSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports